import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Asset } from 'src/app/core/models/insight-configuration.model';
import _ from 'lodash';
import { GetAlgorithmAssetList, SetSelectedAssetList } from 'src/app/core/store/predictive-failure-configuration/predictive-failure-configuration.action';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-asset-selection-popup',
  templateUrl: './asset-selection-popup.component.html',
  styleUrls: ['./asset-selection-popup.component.scss']
})
export class AssetSelectionPopupComponent implements OnInit, AfterViewChecked, OnDestroy {

  public assetList : Asset[]
  public disabledAssetList : Asset[] = [];
  public disabledSelectAll: boolean = false;
  public assetsLoading: boolean = true;

  public count = 0
  public allSelected: boolean = false;
  public someSelected: boolean = false;
  public selectedAlgorithm: any;

  public selectedPlant: any;

  public unsubscribe = new Subject<void>();

  form: UntypedFormGroup;

  constructor(
    public modalRef: BsModalRef,
    public store: Store,
    private fb: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    public router: Router
  ) {
  }

  ngOnInit(): void {
    this.getSelectedPlant();
    this.getAssetList();
    this.initiateForm();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }
  
  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public selectAll(selected: boolean){
    this.allSelected = selected
    if(this.assetList === null) {
      return;
    }
    this.assetList.forEach(asset => asset.selected = selected);
    this.checkSomeSelected();
  }

  public onAssetSelected() {
    this.allSelected = this.assetList !== null && this.assetList.length > 0 && this.assetList.every(asset => asset.selected);
    this.checkSomeSelected();
  }

  public checkSomeSelected() {
    this.someSelected = this.assetList.filter(asset => asset.selected).length > 0 && !this.allSelected;
    this.count = this.assetList.filter(asset => asset.selected).length;
  }

  public initiateForm(): void{
    this.form = this.fb.group({
      asset: this.fb.array([]),
    });
  }

  public getSelectedPlant() {
    //to get the selected Plant option
    this.selectedPlant =  this.store.selectSnapshot(state => state.configurations.selectedPlant);
  }

  public getAssetList() {
    this.assetList = this.store.selectSnapshot(state => state.configurations.predictiveFailure.assetSelection)
    this.filterSelected();
    this.onAssetSelected();
    if(this.assetList.length === 0) {
      this.store.select(state => state.configurations.predictiveFailure.selectedAlgorithm).pipe(takeUntil(this.unsubscribe)).subscribe(algorithm => {
        this.selectedAlgorithm = algorithm;
        this.store.dispatch(new GetAlgorithmAssetList(this.selectedAlgorithm, false))
        .subscribe((state) => {
          this.assetList = state.configurations.predictiveFailure.assetSelection
          this.filterSelected();
          this.onAssetSelected();
          this.assetsLoading = false;
        })
      })
    } else {
      this.assetsLoading = false;
    }
  }

  public filterSelected() {
    const selectedAssets = this.store.selectSnapshot(state => state.configurations.predictiveFailure.assetsSelected);
    const activeAssetList = this.assetList
    .filter((asset) => !asset.configured)
    .map((asset) => {
      asset.selected = !!selectedAssets.find(selectedAsset => selectedAsset.assetId === asset.assetId)
      return asset;
    })

    const disabledAssetList = this.assetList.filter((asset) => asset.configured);

    this.assetList = activeAssetList;
    this.disabledSelectAll = this.assetList.length === 0;
    this.disabledAssetList = disabledAssetList;
  }

  submit() {
    const selectedAssets = _.cloneDeep(this.assetList.filter(asset => asset.selected))
    this.store.dispatch(new SetSelectedAssetList(selectedAssets)).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.modalRef.hide();
    })
    this.store.dispatch(new GetAlgorithmAssetList(this.selectedAlgorithm, false))
  }
  
  public onCloseButtonClick() : void {
    this.modalRef.hide();

    if(this.assetList.length === 0){
      this.router.navigateByUrl('/home')
    }
  }
}
